import { GridOptions } from 'ag-grid-community';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { MetricDefinition } from 'src/shared/models/pipeline-config/metric-definition.models';
import { CxoneManageMetricsService } from '../cxone-manage-metrics.service';

@Component({
    selector: 'cv-associated-metrics',
    templateUrl: './associated-metrics.component.html',
    styleUrls: ['./associated-metrics.component.scss']
})
export class AssociatedMetricsComponent implements OnInit {
    @Input() SelectedMetric: MetricDefinition;
    @Input() metricList: MetricDefinition[];
    @Output() close = new EventEmitter;
    public gridOptions: GridOptions = null;


    constructor(
        private agGridHelperService: AgGridHelperService,
        private service: CxoneManageMetricsService,
        private cvLocalizationService: CVLocalizationService
    ) { }

    ngOnInit(): void {
        this.setupGrid();

    }

    public setupGrid() {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            defaultColDef: {
                sortable: false,
                filter: false,
                resizable: false,
                suppressMenu: true,
                suppressAutoSize: true
            },
            rowData: [],
            getRowId: ({ data: rowData }) => rowData.MetricID.toString(),
            onGridReady: (event) => event.api.sizeColumnsToFit(),
            columnDefs: [
                {
                    field: "MetricID",
                    headerName: this.service.metricLocalization ? this.service.metricLocalization.get("ID_Header") : "ID",
                },
                {
                    field: "Abreviation",
                    headerName: this.service.metricLocalization ?
                        this.service.metricLocalization.get("Metric_Name_Placeholder") : "Metric Name",

                },
                {
                    field: "MetricDescription",
                    headerName: this.service.metricLocalization ?
                        this.service.metricLocalization.get("Description").replace(':', '') : "Description",
                    width: window.innerWidth * 0.42,
                },
            ]
        })

    }

    public CloseModal() {
        this.close.emit();
    }

    getLocalizationString(key: string, defaultValue: string) {
        return this.cvLocalizationService.getCachedText("CXOne_Manage_Metrics", key, defaultValue);
    }

}
